import { Component, inject, signal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BrnDialogRef, injectBrnDialogContext } from '@spartan-ng/brain/dialog';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { MemberMultiselectInputComponent, MemberOption } from '../../molecules';
import { ThemedIconComponent } from '../../atoms';

export interface MemberSelectionDialogData {
  title: string;
  options: MemberOption[];
  selectedIds?: string[];
  placeholder?: string;
  ariaLabel?: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'ocp-member-selection-dialog',
  imports: [HlmButtonImports, MemberMultiselectInputComponent, ThemedIconComponent, TranslatePipe],
  templateUrl: './member-selection-dialog.component.html',
  styleUrl: './member-selection-dialog.component.scss',
})
export class MemberSelectionDialogComponent {
  private readonly dialogRef = inject<BrnDialogRef<string[] | undefined>>(BrnDialogRef, {
    optional: true,
  });
  private readonly dialogContext = injectBrnDialogContext<MemberSelectionDialogData>({
    optional: true,
  });

  protected readonly data: MemberSelectionDialogData = {
    title: this.dialogContext?.title ?? '',
    options: this.dialogContext?.options ?? [],
    selectedIds: this.dialogContext?.selectedIds ?? [],
    placeholder: this.dialogContext?.placeholder ?? '',
    ariaLabel: this.dialogContext?.ariaLabel ?? '',
    confirmLabel: this.dialogContext?.confirmLabel ?? 'Ok',
    cancelLabel: this.dialogContext?.cancelLabel ?? 'Cancel',
  };

  protected readonly selectedIds = signal<string[]>(this.data.selectedIds ?? []);

  protected onMembersChange(memberIds: string[]): void {
    this.selectedIds.set(memberIds);
  }

  protected onConfirm(): void {
    this.dialogRef?.close(this.selectedIds());
  }

  protected onCancel(): void {
    this.dialogRef?.close();
  }
}
